import { html } from "lit";
import { customElement, property } from "lit/decorators.js";

import { BaseElement } from "@/components";

@customElement("sb-title")
export class SbTitle extends BaseElement {
  get _containerElement(): HTMLLIElement | null {
    return this.querySelector(
      `rtg-typography-h[part=${this.id ? this.id : "title"}]`,
    );
  }
  @property({ type: String }) id!: string;
  @property({ type: String }) content!: string;

  protected createRenderRoot() {
    return this;
  }

  render() {
    return html`
      <rtg-typography-h
        part=${this.id ? this.id : "title"}
        level="h4"
        id=${this.id}
      >
        ${this.content}
      </rtg-typography-h>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "sb-title": SbTitle;
  }
}
